import React from "react";
import BottomSheet from "./BottomSheet";
import FanRequestsPanel from "./FanRequestsPanel";
import type { FanUser } from "../lib/fanAccount";
import "./FanProfileSheet.css";
import { t } from "../i18n";

// 🎟️ Fan profile sheet — opened from the header chip on customer pages.
// The whole body lives in FanRequestsPanel (shared with the app's
// My Requests tab); this frame is just the BottomSheet the chip opens —
// `plain` (grab handle only, scrim tap to close, same as the sign-in
// sheet) so the fan's name + photo sit at the very top and the
// "🎟️ My Requests" heading beneath them (founder decision).
// The name row is "My Profile ›" (chevron only) and opens the editor sheet
// ON TOP of this one.

const FanProfileSheet: React.FC<{
  open: boolean;
  onClose: () => void;
  onOpenEditor: () => void;
  onVerifyInstagram?: () => void;
  /** Someone just signed in at the panel's gate. */
  onSignedIn?: (fan: FanUser) => void;
  /** Fan Refer & Earn (signed-in fans; FanRequestsPanel hides it otherwise). */
  onOpenRefer?: () => void;
}> = ({ open, onClose, onOpenEditor, onVerifyInstagram, onSignedIn, onOpenRefer }) => {
  if (!open) return null;

  return (
    <BottomSheet open={open} title={t("fanProfileSheet.myRequests")} onClose={onClose} plain>
      <FanRequestsPanel
        active={open}
        frame="sheet"
        onOpenEditor={onOpenEditor}
        onVerifyInstagram={onVerifyInstagram}
        onSignedIn={onSignedIn}
        onOpenRefer={onOpenRefer}
      />
    </BottomSheet>
  );
};

export default FanProfileSheet;
